module.exports = __webpack_public_path__ + "static/img/img-cancer.9b0c761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c28/img-cancer.png
// module id = wqIE
// module chunks = 0